module.exports = __webpack_public_path__ + "ea718be5745cb55a808b739bc0364d88.pdf";